module.exports = __webpack_public_path__ + "img/darts.b11262bc.svg";